// extracted by mini-css-extract-plugin
export default {"wrapper":"SidebarLayout_wrapper__kdiRm","sidebar":"SidebarLayout_sidebar__a+lEN","sidebar--visible":"SidebarLayout_sidebar--visible__NUd5K","content":"SidebarLayout_content__MP-0P"};